/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserTeamsResponseItems
 */
export interface GetUserTeamsResponseItems {
    /**
     * 
     * @type {string}
     * @memberof GetUserTeamsResponseItems
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserTeamsResponseItems
     */
    teamname: string;
}

export function GetUserTeamsResponseItemsFromJSON(json: any): GetUserTeamsResponseItems {
    return GetUserTeamsResponseItemsFromJSONTyped(json, false);
}

export function GetUserTeamsResponseItemsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserTeamsResponseItems {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'teamname': json['teamname'],
    };
}

export function GetUserTeamsResponseItemsToJSON(value?: GetUserTeamsResponseItems | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'teamname': value.teamname,
    };
}


